import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.paceestate.com';

const getAuthHeader = () => {
  const token = localStorage.getItem('vendor_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const vendorApi = {
  // Sales
  getSales: async () => {
    const response = await axios.get(`${API_URL}/api/vendor/sales`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  getSaleDetail: async (saleId) => {
    const response = await axios.get(`${API_URL}/api/vendor/sales/${saleId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Consignments
  getConsignments: async (status = null) => {
    const params = status ? { status } : {};
    const response = await axios.get(`${API_URL}/api/vendor/consignments`, {
      headers: getAuthHeader(),
      params
    });
    return response.data;
  },

  getConsignmentDetail: async (consignmentId) => {
    const response = await axios.get(`${API_URL}/api/vendor/consignments/${consignmentId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Payouts
  getPayouts: async () => {
    const response = await axios.get(`${API_URL}/api/vendor/payouts`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  getPayoutDetail: async (payoutId) => {
    const response = await axios.get(`${API_URL}/api/vendor/payouts/${payoutId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Financials
  getFinancials: async () => {
    const response = await axios.get(`${API_URL}/api/vendor/financials`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Documents
  getDocuments: async () => {
    const response = await axios.get(`${API_URL}/api/vendor/documents`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Statements
  downloadStatement: async (month, year) => {
    const response = await axios.get(`${API_URL}/api/vendor/statement`, {
      headers: getAuthHeader(),
      params: { month, year },
      responseType: 'blob'
    });
    return response.data;
  }
};

export default vendorApi;
